<template>
    <div>
            <top-navbar></top-navbar>


            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Employee </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/questions/index"> Feedback  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{all_data.code }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->
 <b-modal :id="infoModal2.id"
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
hide-footer
     >
    <template   #modal-title>

      <h3 >Pie Chart</h3>



    </template>

    <chart-card class="bdr-rad2 shadow  p-1" v-if="loadchart"
  :chart-data="pieChart1.data"
  :chart-options="pieChart1.options"
  :chart-responsive-options="pieChart1.responsiveOptions"
  chart-type="Pie"
  >
 
    </chart-card>

   


  </b-modal>
  


                <div class="d-grid gap-2 d-md-flex justify-content-md-end">

                 

                  <button v-if="all_data.status==55"  @click="Inactive()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Inactive</button>
                  <button v-if="all_data.status==2"  @click="Active()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Published</button>
                  <button v-if="all_data.status==1"  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                  <button v-if="all_data.status==1"  @click="Confimmodel()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                



                </div>

              




                <b-modal :id="infoModal1.id"
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"

     bottom>
    <template   #modal-title>

      <h3 >Confirm !</h3>



    </template>

    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm ?</h5>
    </div>
    <hr>

    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>


  </b-modal>


            <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >




                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">

                        <tbody >


                          <tr>
                            <td class="width-custom2"><b>Questionnaire Code </b></td>
                           <td>{{ all_data.code }}</td>
                          </tr>
                          <tr>
                            <td><b>Questionnaire Name</b></td>
                           <td>{{ all_data.questionnaire_name }}</td>
                          </tr>
                           <tr>
                            <td><b>Show Type</b></td>
                           <td>{{ all_data.userchech }}</td>
                          </tr>
                          <tr>
                            <td><b>status</b></td>
                           <td>{{ all_data.relatedToStatus.status }}</td>
                          </tr>
                          <tr v-if="all_data.status == 55">
                            <td ><b>Link</b></td>
                           <td class="d-flex align-items-center">
  <a
    :href="`http://localhost:8080/questions/answer?id=${all_data.id}`"
    target="_blank"
    class="mr-2"
  >
    http://localhost:8080/questions/answer?id={{ all_data.id }}
  </a>

   <button  type=""  @click="copyLink(all_data.id)" class="mr-1 btn btn-sm btn-outline-primary  mb-1 font-size_def bdr-rad"> Copy link</button>
  
</td>
                          </tr>

                         
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ all_data.created_date }}</td>
                          </tr>
                          <tr>
                            <td><b>Created By</b></td>
                           <td>{{ all_data.relatedToUser.username }}</td>
                          </tr>

                        


                        </tbody>


                      </table>

                      </div>
                      </div>



                      <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Questionnaire</b></h6>

   <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Category</th>
                              <th >Question</th>
                              <th >Remarks</th>
                              <th >Select Choices</th>
                              <th >Action</th>
                              
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{detail.Category}}</td>
                              <td >{{detail.Question}}</td>
                              <td >{{detail.remark}}</td>
                              <td > <span v-for="(c, index) in detail.choises" :key="index">
                                    {{ c.label }}<br>
                                    </span>
                                </td>

                                <td>
                                 <button
  type="button"
  class=" btn btn-sm btn-outline-primary mb-1 font-size_def bdr-rad" @click="chartShow(detail.id)"
  
>
 Chart
</button>
                                </td>
                             
                             </tr>
                             
                             
                            </tbody>

                          </table>
                        </div>


            </div>
        </div>




                              <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Answer Sheet</b></h6>

   <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Name</th>
                              <th >Email</th>
                              <th >Tel</th>
                              <th >Date</th>
                              <th >Status</th>
                              <th >Action</th>
                              
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(det, index) in dets" :key="det.id">
                              <td>{{ index+1 }}</td>
                              <td>{{det.usertype}}</td>
                              <td >{{det.email}}</td>
                              <td >{{det.phone}}</td>
                            
                                 <td >{{det.created_date}}</td>
                                   <td >{{det.status}}</td>
                                 <td>  <button
  type="button"
  class="mr-1 btn btn-sm btn-outline-primary mb-1 font-size_def bdr-rad"
  @click="Viewresult(det.id)"
>
View
</button></td>
                             
                             </tr>
                             
                             
                            </tbody>

                          </table>
                        </div>


            </div>
        </div>









<br><br>










                </div>
                </div>
              </div>
            </div>

            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
      import ChartCard from './../../components/Cards/ChartCard.vue'
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'



      export default {

        mounted(){
    this.loadAlldata()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
            total:{},
            loadchart:false,
            all_data:{},
            category:{},
            isLoading:true,
            brand:{},
            supplier:{},
            status:{},
            user:{},
            all_code:{},
            crm:{},
            // isLoading:true,
            details:[],
            dets:[],
            mservicelogs:[],
            trans:[],
            width:5,
            height:5,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
            infoModal2: {
          id: 'info-modal2',
          title: '',
          content: {},
        },
        pieChart1: {
  data: {
    labels: [],   // array of labels
    series: []    // array of numbers
  }
},

        // imageUrl: '/img/evenware-logo.png'

          }

        },
        components :{

            ContentFooter,
            TopNavbar,
               ChartCard,

        },

        methods : {

  copyLink(id) {
    const link = `http://localhost:8080/questions/answer?id=${id}`;
    navigator.clipboard.writeText(link).then(() => {
      this.$bvToast.toast('Link copied!', {
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 2000
      });
    });
  },
       
          async Confirm(id) {


       try {
         const { data} = await  axios.get('/questions/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadAlldata();

            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },
          async Inactive() {


       try {
         const { data} = await  axios.get('/questions/inactive?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadAlldata();

            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },
          async Active() {


       try {
         const { data} = await  axios.get('/questions/active?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadAlldata();

            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },


    


          async Update(){
        this.$router.push('/questions/update?id='+this.id);
      },
          async Viewresult(id){
        this.$router.push('/questions/answersheet?id='+id);
      },

      async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);

      },
      async chartShow(id){

         try {
        const { data} = await  axios.post('/questions/piechart',{pepar_id:this.id,pepar_det_id:id},{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data.dets);
         console.log(data.dets.label);
            this.pieChart1.data.labels = data.dets.label;
    this.pieChart1.data.series = data.dets.series;

           this.loadchart = true;
            this.infoModal2.content = id;
            this.$root.$emit('bv::show::modal', this.infoModal2.id);

            console.log('aaaa');

      } catch (error) {
        console.log(error.response);
      }


       

      },
         

            async loadAlldata() {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/questions/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data);
         this.all_data = data.all_data;
        
         this.details = data.details;
         this.dets = data.dets;

          this.isLoading = false;
      

      } catch (error) {
        console.log(error.response);
      }
    },







    },

    }

    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;



  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>
